import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable'; // FIXED IMPORT
import { useNavigate } from 'react-router-dom';
import './ChatInterface.css';

// ⚠️ SECURITY NOTE: Ideally, keep this in a .env file (process.env.REACT_APP_OPENAI_API_KEY)
const OPENAI_API_KEY = "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"; 


// --- OFFICIAL MASTER TEMPLATE ---
// The AI will fill this template only AFTER the interview is complete.
const MASTER_TEMPLATE = `
# SECTION 1: INVITATION FOR PROPOSALS (IFP)

[COMPANY_NAME] invites sealed proposals through e-tendering process from eligible and qualified consulting firms for **[PROJECT_TITLE]**.

1. **Objective:** [COMPANY_NAME] requires a qualified agency to undertake **[SCOPE_SUMMARY]**.
2. **Selection Method:** The selection will be conducted under the Quality and Cost Based Selection (QCBS) method.
3. **Key Dates:**

| Activity | Date | Time |
| Date of Issue of RFP | [      ] | 10:00 Hrs |
| Pre-Bid Meeting | [       ] | 15:00 Hrs |
| Last Date for Submission | [DEADLINE_DATE] | 18:00 Hrs |
| Technical Bid Opening | [DATE_OPENING] | 15:00 Hrs |

# SECTION 2: INSTRUCTIONS TO CONSULTANTS (ITC)

**1. Eligibility Criteria:**
The Consultant must meet the following mandatory criteria:
* **Legal Entity:** Must be a registered legal entity.
* **Experience:** Minimum **[ELIGIBILITY_YEARS]** years of experience in similar projects.
* **Turnover:** Average Annual Turnover of **[ELIGIBILITY_TURNOVER]** in the last 3 financial years.
* **Non-Blacklisting:** Must not be blacklisted by any Central/State Govt/PSU.

**2. Cost of Bidding:**
The Consultant shall bear all costs associated with the preparation and submission of its proposal. [COMPANY_NAME] will not be responsible or liable for those costs.

**3. Submission of Proposals:**
Proposals must be submitted online. No physical submission will be accepted.

# SECTION 3: TERMS OF REFERENCE (TOR)

**1. Detailed Scope of Work:**
[INSERT_DETAILED_SCOPE_HERE]

**2. Deliverables & Timeline:**
The assignment is expected to be completed within **[DURATION]**.
* **Inception Report:** Within 15 days.
* **Draft Report/Deliverable:** Within [DURATION_HALF].
* **Final Report/Go-Live:** End of Contract.

# SECTION 4: EVALUATION CRITERIA (QCBS)

The Technical Proposals will be evaluated based on the following criteria (Max 100 Marks):

| Evaluation Parameter | Max Marks |
|---|---|
| **1. Firm Experience** | **25** |
| a. Overall Experience in similar domain | 15 |
| b. Specific Experience with Govt/PSU | 10 |
| **2. Methodology & Understanding** | **30** |
| a. Understanding of Objectives | 15 |
| b. Proposed Methodology & Work Plan | 15 |
| **3. Key Personnel** | **35** |
| a. Team Leader (10+ Years Exp) | 15 |
| b. Domain Expert | 10 |
| c. Technical Lead | 10 |
| **4. Financial Strength (Turnover)** | **10** |
| **Total** | **100** |

*Minimum Qualifying Marks: 60/100*

# SECTION 5: GENERAL TERMS AND CONDITIONS (GTC)

**1. Payment Terms:**
Payments will be released based on the following milestones:

| Milestone | Deliverable | % Payment |
|---|---|---|
| 1 | Inception Report | 10% |
| 2 | Draft Deliverable / Interim Report | 30% |
| 3 | Final Deliverable / UAT Sign-off | 30% |
| 4 | Project Closure & Handover | 30% |

**2. Earnest Money Deposit (EMD):**
The bidder must submit an EMD of **[EMD_AMOUNT]**. MSME firms are exempted from EMD submission upon production of valid certificate.

**3. Performance Security:**
The successful Consultant shall furnish a Performance Security equivalent to **5% of the total contract value** in the form of a Bank Guarantee valid for the contract duration plus 3 months.

**4. Liquidated Damages (LD):**
LD shall be calculated at **0.5% of the total contract value for each week of delay**, subject to a maximum of **10%** of the total contract value.

**5. Arbitration:**
"Any dispute or difference arising out of or concerning the contract shall be referred to arbitration in accordance with the provisions of the Arbitration and Conciliation Act, 1996."

**6. Jurisdiction:**
"The contract shall be governed by the laws of India."

# ANNEXURE 1: INTEGRITY PACT

**BETWEEN**
[COMPANY_NAME] **AND** The Bidder.

**Preamble**
This pre-bid pre-contract Agreement (Integrity Pact) is made to avoid all forms of corruption by following a system that is fair, transparent and free from any influence.

**Article 1: Commitment of [COMPANY_NAME]**
(1) [COMPANY_NAME] commits itself to take all measures necessary to prevent corruption. No employee of [COMPANY_NAME] will demand or accept any material or immaterial benefit to which they are not legally entitled.
(2) [COMPANY_NAME] will treat all Bidders with equity and reason.

**Article 2: Commitment of the Bidder**
(1) The Bidder commits to take all measures to prevent corruption.
(2) The Bidder will not, directly or through any other person, offer any illegal benefit to [COMPANY_NAME] employees.
(3) The Bidder will not enter into any undisclosed agreement or understanding with other bidders (cartelization).
(4) The Bidder will not commit any offence under the Prevention of Corruption Act, 1988.

**Article 3: Sanctions for Violation**
If the Bidder breaches this Pact, [COMPANY_NAME] shall have the right to:
(i) Disqualify the Bidder from the tender process.
(ii) Forfeit the EMD or Performance Security.
(iii) Debar the Bidder from participating in tenders for a period up to 5 years.
(iv) Recover all sums paid in violation of this pact.

**Article 4: Independent External Monitors (IEMs)**
[COMPANY_NAME] has appointed Independent External Monitors to review compliance with this Pact. The Monitors shall have unrestricted access to all Project documentation.

**Article 8: Duration of the Pact**
This Pact begins when signed and ends upon the complete execution of the contract (including warranty/defect liability).

**IN WITNESS WHEREOF** the parties have signed and executed this Integrity Pact.
`;

const Generator = () => {
  const navigate = useNavigate();
  const [showHistory, setShowHistory] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(false);
  const [isOn, setIsOn] = useState(true);
  const fileInputRef = useRef(null);
  const [messages, setMessages] = useState([
    { role: 'system', content: `You are the Official RFP Drafter.
    
    **PHASE 1: THE INTERVIEW (MANDATORY)**
    You must NOT ask for all details at once. You must ask these questions **ONE BY ONE**:
    1. Ask for **Company Name** (Issuing Authority). Wait for user input.
    2. Ask for **Project Title**. Wait for user input.
    3. Ask for **Scope of Work** (What needs to be built?). Wait for user input.
    4. Ask for **Contract Duration** (e.g., 6 months). Wait for user input.
    5. Ask for **Deadline Date** for submission. Wait for user input.
    6. Ask for **EMD Amount** (e.g., 50,000 INR). Wait for user input.
    7. Ask for **Eligibility Criteria** (Turnover/Experience). Wait for user input.

    **PHASE 2: THE GENERATION**
    ONLY when you have all answers, proceed to generate the RFP.
    
    **GENERATION INSTRUCTIONS:**
    1. Use the **MASTER TEMPLATE** below.
    2. Replace the bracketed placeholders [COMPANY_NAME], [PROJECT_TITLE], [SCOPE_SUMMARY], [DEADLINE_DATE], etc., with the collected data.
    3. **Expand** the [INSERT_DETAILED_SCOPE_HERE] section into 3-4 professional paragraphs based on the user's "Scope of Work" input. Ensure this section is detailed and technical.
    4. Keep the legal text, tables, and integrity pact **EXACTLY** as shown in the template.
    5. Wrap the output in [FINAL_RFP_START] and [FINAL_RFP_END].

    **MASTER TEMPLATE:**
    ${MASTER_TEMPLATE}` },
    
    // CHANGED: The initial message now only asks the FIRST question.
    { role: 'assistant', content: "Hello. I am the RFP Drafting System.\n\nTo begin, please tell me: **What is the Name of the Company issuing this RFP?**" }
  ]);
  
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Thinking');
  const [generatedRFP, setGeneratedRFP] = useState(null);
  const chatEndRef = useRef(null);

  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages, isLoading]);

  const handleSend = async () => {
    if (!input.trim()) return;
    const newMsg = { role: 'user', content: input };
    const updatedMessages = [...messages, newMsg];
    setMessages(updatedMessages);
    setInput('');
    setIsLoading(true);
    setLoadingText('Thinking...');

    try {
      const response = await axios.post(
        'https://api.openai.com/v1/chat/completions',
        {
      model: "gpt-4o-mini",
          messages: updatedMessages.map(m => ({ role: m.role, content: m.content })),
          temperature: 0.3, 
        },
        { headers: { 'Authorization': `Bearer ${OPENAI_API_KEY}` } }
      );

      const botContent = response.data.choices[0].message.content;
      setMessages(prev => [...prev, { role: 'assistant', content: botContent }]);

      if (botContent.includes("[FINAL_RFP_START]")) {
        const rfpText = botContent.split("[FINAL_RFP_START]")[1].split("[FINAL_RFP_END]")[0];
        setGeneratedRFP(rfpText.trim());
        setLoadingText('Generating PDF...');
      }

    } catch (error) {
      console.error("API Error:", error);
      setMessages(prev => [...prev, { role: 'assistant', content: "Error. Please check your API Key." }]);
    } finally {
      setIsLoading(false);
    }
  };

  const generatePDF = () => {
    if (!generatedRFP) return;
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 20;
    const maxLineWidth = pageWidth - (margin * 2);
    
    // --- COVER PAGE ---
    doc.setFillColor(26, 82, 118); // JCI Blue
    doc.rect(0, 0, pageWidth, 297, 'F');
    doc.setFillColor(255, 255, 255);
    doc.rect(20, 50, pageWidth - 40, pageHeight - 100, 'F');

    doc.setFont("times", "bold");
    doc.setTextColor(26, 82, 118);
    doc.setFontSize(26);
    doc.text("REQUEST FOR PROPOSAL", pageWidth / 2, 90, { align: 'center' });
    
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100);
    doc.text("Official Tender Document", pageWidth / 2, 105, { align: 'center' });
    
    // Extract Company Name from RFP
    let companyName = "Issuing Authority";
    const companyMatch = generatedRFP.match(/^(.+?) invites sealed proposals/m);
    if (companyMatch && companyMatch[1]) {
        companyName = companyMatch[1].replace(/\*\*/g, '').trim();
    }

    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.text("Issued By:", pageWidth / 2, 220, { align: 'center' });
    doc.setFont("helvetica", "bold");
    doc.text(companyName, pageWidth / 2, 230, { align: 'center' });
    
    doc.addPage();

    // --- CONTENT GENERATION ---
    let y = 20;
    doc.setTextColor(0);
    
    const lines = generatedRFP.split('\n');
    let isTableMode = false;
    let tableHeader = [];
    let tableBody = [];

    lines.forEach((line, index) => {
      const trimmedLine = line.trim();

      // --- TABLE START/END DETECTION ---
      if (trimmedLine.startsWith('|')) {
        isTableMode = true;
        const row = trimmedLine.split('|').filter(c => c.trim() !== '').map(c => c.trim());
        if (trimmedLine.includes('---')) return; // Skip Markdown separator
        
        if (tableHeader.length === 0) {
            tableHeader = row;
        } else {
            tableBody.push(row);
        }
        return; // Don't print table lines as text
      }

      // --- RENDER TABLE ---
      if (isTableMode && (!trimmedLine.startsWith('|') || index === lines.length - 1)) {
        if (tableHeader.length > 0) {
            // FIX: Explicitly call autoTable(doc, options)
            autoTable(doc, {
                startY: y,
                head: [tableHeader],
                body: tableBody,
                theme: 'grid',
                headStyles: { fillColor: [26, 82, 118], textColor: 255, fontStyle: 'bold' },
                styles: { fontSize: 10, cellPadding: 3, overflow: 'linebreak' },
                margin: { left: margin, right: margin }
            });
            y = doc.lastAutoTable.finalY + 12;
        }
        isTableMode = false;
        tableHeader = [];
        tableBody = [];
      }

      // --- PAGE BREAK CHECK ---
      if (y > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }

      // --- TEXT RENDERING ---
      if (!isTableMode && trimmedLine.length > 0) {
        if (trimmedLine.startsWith('# ')) {
            if (y > 20) {
                doc.addPage();
                y = 20;
            }
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.setTextColor(26, 82, 118);
            doc.text(trimmedLine.replace('#', '').trim(), margin, y);
            y += 5;
            doc.setLineWidth(0.5);
            doc.line(margin, y, pageWidth - margin, y);
            y += 10;
        } else if (trimmedLine.startsWith('**')) {
             // Simple bold handling
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.setTextColor(0);
            const text = trimmedLine.replace(/\*\*/g, '');
            doc.text(text, margin, y);
            y += 6;
        } else {
            doc.setFont("times", "normal");
            doc.setFontSize(11);
            doc.setTextColor(0);
            const text = trimmedLine.replace(/\*\*/g, '');
            const splitText = doc.splitTextToSize(text, maxLineWidth);
            doc.text(splitText, margin, y);
            y += (splitText.length * 5) + 2;
        }
      }
    });

    // --- FOOTER ---
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
    }

    doc.save("JCI_Official_RFP.pdf");
  };

  return (
    <div className="d-flex vh-100 overflow-hidden app-theme-bg">
      <div className="flex-grow-1 d-flex flex-column">
        <div className="cx-chat-body flex-grow-1 p-3  mt-5 p-md-4">
          <div className="cx-chat-panel bg-white rounded-3 shadow-sm h-100 d-flex flex-column">
            
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between px-3 px-md-4 border-bottom cx-chat-topbar">
              <div className="d-flex align-items-center gap-3 flex-grow-1">
                <button className="btn btn-link p-0" onClick={() => navigate(-1)}>
                  <img src="/images/Arrow.svg" width="18" alt="Back" />
                </button>
                <div className="cx-avatar-circle cx-avatar-finance">
                   <i className="bi bi-robot text-white fs-5"></i>
                </div>
                <div>
                  <div className="fw-medium">RFP Generator</div>
                  <div className="cx-agent-domain-text">AI Generator</div>
                </div>
              </div>
              
              <div className="d-flex align-items-center gap-2 gap-md-3">
                {generatedRFP && (
                  <button className="btn btn-danger btn-sm d-flex align-items-center gap-2" onClick={generatePDF}>
                    <i className="bi bi-file-earmark-pdf"></i>
                    <span className="d-none d-md-inline">Download PDF</span>
                  </button>
                )}
                
                <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2">
                  <i className="bi bi-share"></i>
                  <span className="d-none d-md-inline">Share Chat</span>
                </button>

                <button className="btn btn-sm d-flex align-items-center gap-2 button-internet">
                  <i className="bi bi-globe"></i>
                  <span className="d-none d-md-inline">Internet Assistance</span>
                </button>

                <div className="form-check form-switch m-0">
                  <input 
                    className="form-check-input cx-toggle-input" 
                    type="checkbox" 
                    checked={isOn} 
                    onChange={() => setIsOn(!isOn)} 
                  />
                </div>
              </div>
            </div>

            {/* Chat Area */}
            <div className="cx-chat-container flex-grow-1 position-relative bg-white">
              
              {/* Left Panel - History */}
              <aside className={`cx-left-panel position-absolute start-0 top-0 h-100 d-flex ${showHistory ? "is-open" : ""}`}>
                <div className="cx-left-toggle d-flex flex-column align-items-center pt-3">
                  <button className="btn p-0 border-0 bg-transparent" onClick={() => setShowHistory(!showHistory)}>
                    <div className="cx-left-icon d-flex align-items-center justify-content-center">
                      <img src="/images/Reader.svg" alt="Reader" />
                    </div>
                  </button>
                </div>
                {showHistory && (
                  <div className="flex-grow-1 bg-white h-100 overflow-auto">
                    <div className="p-3">
                      <h6 className="fw-semibold mb-3">Chat History</h6>
                      <div className="p-2 rounded-3 mb-2 chathistory-details">
                        <div className="fw-medium text-truncate">RFP Generation Session</div>
                        <div className="d-flex justify-content-between align-items-center mt-1">
                          <small className="text-muted">Just now</small>
                          <button className="btn btn-link p-0 text-muted">
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </aside>

              {/* Right Panel - Smart Window */}
              <div className={`cx-right-panel position-absolute end-0 top-0 h-100 d-flex ${showRightPanel ? "is-open" : ""}`}>
                <div className="cx-right-toggle d-flex flex-column align-items-center pt-3">
                  <button className="btn p-0 border-0 bg-transparent" onClick={() => setShowRightPanel(!showRightPanel)}>
                    <div className="cx-right-toggle-icon d-flex align-items-center justify-content-center">
                      <img src="/images/Reader.svg" alt="Reader" />
                    </div>
                  </button>
                </div>
                {showRightPanel && (
                  <div className="flex-grow-1 bg-white h-100 overflow-auto">
                    <div className="p-3">
                      <h6 className="fw-semibold mb-3">Smart Window</h6>
                      <div className="text-muted small">
                        Contextual information and extracted entities from the RFP generation process will appear here.
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Center Chat */}
              <div className={`cx-chat-center d-flex flex-column h-100 ${showHistory ? "has-left" : ""} ${showRightPanel ? "has-right" : ""}`}>
                
                <div className="cx-messages-container flex-grow-1 overflow-auto py-4 px-3">
                  {messages.filter(m => m.role !== 'system').map((msg, idx) => (
                    <div key={idx} className={`d-flex mb-3 ${msg.role === 'user' ? 'justify-content-end' : 'justify-content-start'}`}>
                      <div className="cx-msg-maxwidth">
                        <div className={`p-3 rounded-3 cx-message-bubble ${msg.role === 'user' ? 'is-user' : 'is-agent'}`}>
                          {msg.content.replace("[FINAL_RFP_START]", "").replace("[FINAL_RFP_END]", "")}
                          <div className="text-end mt-1 cx-message-time">
                            {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                          </div>
                        </div>
                        
                        {/* Agent Meta Info */}
                        {msg.role === 'assistant' && (
                          <div className="mt-2 px-2">
                            <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
                              <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span className="text-muted cx-confidence-label">Confidence:</span>
                                <span className="px-2 py-1 rounded text-white cx-confidence-badge">High</span>
                                <span className="text-primary cx-sources-link">Data found in JCI Templates</span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <StarRating value={4} />
                                <i className="bi bi-three-dots-vertical cx-clickable"></i>
                              </div>
                            </div>
                            <div className="d-flex gap-2 flex-wrap">
                               {generatedRFP && msg.content.includes("[FINAL_RFP_START]") && (
                                  <button className="btn btn-outline-secondary btn-sm" onClick={generatePDF}>
                                    ✨ Download PDF
                                  </button>
                               )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  
                  {isLoading && (
                    <div className="d-flex mb-3 justify-content-start">
                      <div className="cx-msg-maxwidth">
                        <div className="p-3 rounded-3 cx-message-bubble is-agent">
                           <div className="d-flex align-items-center gap-2">
                              <span>{loadingText}</span>
                              <div className="spinner-grow spinner-grow-sm" role="status"></div>
                              <div className="spinner-grow spinner-grow-sm" role="status"></div>
                              <div className="spinner-grow spinner-grow-sm" role="status"></div>
                           </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div ref={chatEndRef} />
                </div>

                {/* Input */}
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-10'>
                          <div className="cx-chat-input-footer w-100 d-flex align-items-center gap-2 px-3 py-2 border rounded-3 shadow-sm mb-3 mx-auto">
                   <img src="/images/Media.svg" alt="Attach" className="cx-clickable" onClick={() => fileInputRef.current?.click()} />
                   <input type="file" ref={fileInputRef} className="d-none" />
                   <input 
                      className="form-control border-0 shadow-none"
                      placeholder="Type your answer..."
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                      disabled={isLoading}
                   />
                   <i className="bi bi-mic text-muted fs-5"></i>
                   <button className="btn btn-primary d-flex align-items-center justify-content-center cx-send-btn" onClick={handleSend} disabled={isLoading}>
                      <i className="bi bi-arrow-up"></i>
                   </button>
                </div>
                    </div>
                    <div className='col-1'></div>
                </div>
              

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

function StarRating({ value = 0, max = 5 }) {
  return (
   <div className="d-flex align-items-center gap-1 cx-star-rating">
  {[...Array(max)].map((_, i) => (
    <i
      key={i}
      className={`bi cx-star ${
        i < value ? "cx-star-filled bi-star-fill" : "cx-star-empty bi-star"
      }`}
    />
  ))}
</div>
  );
}

export default Generator;